import { Injectable } from '@angular/core';
import { Effect, ofType, Actions } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { exhaustMap, map, catchError } from 'rxjs/operators';
import { User } from '../../types/users.types';
import { UsersService } from '../../services/users.service';
import { LoadUsersSuccess, LoadUsersFail, UsersActionTypes } from './actions';

@Injectable()
export class UsersEffects {
  constructor(private actions$: Actions, private usersService: UsersService) {}

  @Effect()
  loadUsers$: Observable<
    LoadUsersSuccess | LoadUsersFail | never
  > = this.actions$.pipe(
    ofType(UsersActionTypes.Load),
    exhaustMap(() =>
      this.usersService.getUsers().pipe(
        map((users: User[]) => new LoadUsersSuccess(users)),
        catchError((error: Error) => of(new LoadUsersFail(error.message)))
      )
    )
  );
}
